import React from "react";
//import Sidebar from "../../Components/sidebar/sideBar";
//import Top_bar from "../../Components/topBar/topBar";
import TableList from "../../Components/tableList/TableList";
import "../Prelude/prelude.css";
import "../../Components/reports/reports.css";
import InputReport from "../../Components/inputReport/inputReport";
import Api from "../../services/api";
import moment from "moment";
import DatePicker from "../../Components/datePicker/datePicker";
import MessageTable from "../../Components/messageTable/MessageTable";
import ExcelButton from "../../Components/exportExcelButton/ExportExcelButton";
import Button from '../../Components/commonButton/commonButton';
import Spinner from "react-bootstrap/Spinner";
import styles from "../General/details.module.css";
import "./generalReports.css";
//import BottomBar from "../../Components/bottomBar/bottomBar";
//import { faFilter } from "@fortawesome/free-solid-svg-icons";
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FilterBox from "../../Components/filterBox/filterBox";
import Select from "../../Components/select/select";
import api from "../../services/api";

class reportsOrders extends React.Component {
  state = {
    data: [],
    dataFinal: null,
    blockFinalData: false,
    initialData: [],
    arrayFilter: [],
    code: null,
    dataAux: "",
    render: false,
    reasons: [],
    start_date: { name: "start_date", date: new Date().toLocaleDateString('pt-BR') },
    end_date: { name: "end_date", date: new Date().toLocaleDateString('pt-BR') },
    Máquina: { name: "Máquina", value: "" },
    Item: { name: "Item", value: "" },
    Código: { name: "Código", value: "" },
    loading: false,
    message:"Preencha os filtros e clique em gerar",
    workshifts: [{value: null, label: "Todos"}],
    workshift: null
  };

  async componentDidMount() {

    await Api.get("/reasons-stop")
      .then((resp) => {
        let arr = [];
        resp.data.response.forEach((element) => {
          arr.push({ value: element.description });
        });
        this.setState({ reasons: arr });
      })
      .catch((error) => {
        console.log(error);
      });

      this.getWorkShifts();
  }

  saveData = (data) => {
    this.setState({ data: data });
  };
  saveFinalData = (data) => {
    this.setState({ finalData: data });
  };

  filter = (data, name) => {
    if (this.state[`${name}`].name === name) {
      let FilterCamp = this.state[`${name}`];
      FilterCamp.value = data;
      this.setState({ [`${FilterCamp.name}`]: FilterCamp });
    }
  };

  saveText = (data) => {
    const { value, name } = data;
    this.filter(value, name);
  };

  filterData = (data, name) => {
    if (this.state[`${name}`].name === name) {
      let dateFilterCamp = this.state[`${name}`];
      dateFilterCamp.date = data;
      this.setState({ [`${dateFilterCamp.name}`]: dateFilterCamp });
    }
  };

  excelbutton = (event) =>{
    if(this.state.data.length === 0){
        alert("Preencha um campo de filtro")
        event.preventDefault()
    }
       
  }

  selectWs = (data)=>{
    this.setState({workshift: data});
  }

  getWorkShifts = ()=>{
    api.get("/work-shifts/").then((resp)=>{
      if(resp.data.length > 0){
        let wsPrev = this.state.workshifts;
        resp.data.forEach((element)=>{
          wsPrev.push({value: element.id, label: element.code});
        })
        this.setState({workshifts: wsPrev});
      }
    })
  }

  sendData = () => {
    const params = {
      m: this.state.Máquina.value,
      i: this.state.Item.value,
      c: this.state.Código.value,
      dt_ini: this.state.start_date.date,
      dt_end: this.state.end_date.date,
      ws: this.state.workshift
    }
    let count = 0
    for (let p in params) {
      if (params[p])
        count++
    }
    if (count > 0) {
      if (!this.state.loading) this.setState({ loading: true });
      Api.get(`/reports/stops/`, { params: params }
      ).then((resp) => {
        let arr = [];
        if (resp.data.length === 0) {
          this.setState({ render: false,message:"Sem dados para processar."});
        } else {
          resp.data.forEach((element) => {
            arr.push({
              Máquina: element.Máquina,
              Ordem: element.Ordem,
              Item: element.Item,
              Operador: element.Operador,
              Código: element.Código.toString(),
              Motivo: element.Motivo,
              Data: moment(element.Data).format("DD/MM/YYYY"),
              Início: element.Início,
              Fim: element.Fim,
              Tempo: element.Tempo,
              Turno: element.Turno,
              Setor: element.Setor,
              Detalhes: element["Detalhes"]
            });
          });
          this.setState({ data: arr, render: true, initialData: arr });
        }
      }).catch((err) => {
          this.setState({ render: false,message:"Sem dados para processar"});

        }).finally(()=>{
          if (this.state.loading) this.setState({ loading: false });
        })
    } else {
      alert("Preencha um campo de filtro");
    }
  }

  render() {
    return (
      <>
          <div className="filters boxReport">
          
            <FilterBox title="Filtros">
            <div className="elementFilter" type="input">
                  <InputReport
                    name="Máquina"
                    parentCallback={this.saveText}
                    title="Máquina"
                    focus={true}
                  />
              </div>
              <div classNme="elementFilter" type="input">
                <InputReport
                  name="Item"
                  parentCallback={this.saveText}
                  title="Item"
                />
              </div>
              <div className="elementFilter" type="input">
                <InputReport
                  name="Código"
                  parentCallback={this.saveText}
                  title="Código"
                />
              </div>
              <div className="elementFilter" type="input">
                <DatePicker
                  name="Data"
                  title="Data Inicial"
                  parentCallback={(e) => this.filterData(e, "start_date")}
                ></DatePicker>
              </div>
              <div className="elementFilter" type="input">
                <DatePicker
                  name="Data"
                  title="Data Final"
                  parentCallback={(e) => this.filterData(e, "end_date")}
                ></DatePicker>
              </div>
              <div className="elementFilter" type="input" id="filterSelect">
              <Select label="Turno" arrData={this.state.workshifts} handleSelect={(e)=>{this.selectWs(e)}} />
            </div>
              <div type="input" className="boxButtons-reportstops">
              <div className="buttonFilter">
                <ExcelButton onClick={this.excelbutton}
                  data={this.state.data}
                  filename={`paradas_${moment()
                    .utc()
                    .utcOffset("-03:00")
                    .format("DDMMYY_HHmmss")}.csv`}
                />
              </div>
              <div className="buttonFilter">
                <Button size title="Gerar" icon="faGear" parentCallback={this.sendData} />
              </div>
              </div>
              
        
            </FilterBox>
            {this.state.loading ? (
              <div className="TableReport">
                <div style={{ marginTop: '20vh' }} className={styles.loader}>
                  <Spinner variant="success" animation="border" />
                  <strong>Carregando...</strong>
                </div>
              </div>
            ) : (
                <>
                {this.state.render ? (
                  <div className="TableReport">
                    <TableList data={this.state.data}></TableList>
                 </div>
                ) : (
                  <div className="TableReport">
                    <MessageTable message={"Sem dados para processar."} />
                  </div>
                )}
                </>
            )}
          </div>
      </>
    );
  }
}

export default reportsOrders;